import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App"; // Pehle yahan EmployeeApp tha, ise App kar diya hai
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap load karne ke liye

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
